module.exports = [{
      plugin: require('/Users/xvision/React/xvisionSite/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/Users/xvision/React/xvisionSite/src/components/Layout.js"},
    },{
      plugin: require('/Users/xvision/React/xvisionSite/node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
